"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.toggleCategory = exports.setPermissionSelection = exports.archiveFailed = exports.archiveSuccess = exports.archiveRequest = void 0;
const ActionTypes = require("../../actionTypes/subproject/archive");
const archiveRequest = (payload) => ({
    type: ActionTypes.ARCHIVE_REQUEST,
    payload
});
exports.archiveRequest = archiveRequest;
const archiveSuccess = () => ({
    type: ActionTypes.ARCHIVE_SUCCESS
});
exports.archiveSuccess = archiveSuccess;
const archiveFailed = (error) => ({
    type: ActionTypes.ARCHIVE_FAILED,
    payload: error
});
exports.archiveFailed = archiveFailed;
const setPermissionSelection = (status) => ({
    type: ActionTypes.SET_PERMISSION_SELECTION,
    payload: status
});
exports.setPermissionSelection = setPermissionSelection;
const toggleCategory = (groups) => ({
    type: ActionTypes.TOGGLE_CATEGORY,
    payload: groups
});
exports.toggleCategory = toggleCategory;
const clear = () => ({
    type: ActionTypes.CLEAR
});
exports.clear = clear;
//# sourceMappingURL=archive.js.map